import { useDispatch } from 'react-redux';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';

export const useResendInvite = (name: string, email: string) => {
    const dispatch = useDispatch();

    return () => {
        dispatch(
            showModalAction({
                modalName: ModalName.RESEND_INVITE,
                modalTitle: 'Resend Invite',
                modalProps: {
                    user: { name, email },
                    note: `Are you sure you want to resend the invite to ${email}?`,
                    border: false,
                },
            }),
        );
    };
};
